<template>
  <MountingPortal mountTo="#sixth">
    <div id="sixthslide" class="sixthslide" style="position:relative">
      <div class="headingstyle">Achievements</div>
      <div id="span"></div>
      <div class="honbe headitit">
        <img :src="Animation" alt="Animation" />
      </div>
      <div class="hqiq headitit">
        <img :src="Party" alt="Animation" />
      </div>
      <br />
      <br />
      <main>
        <ol class="gradient-list">
          <li>
            <h3><b style="font-family:'Poppins'">JEE Mains and Advanced</b></h3>
            <div style="text-align:left;padding-top:5px">
              <div>
                (a) I cleared JEE Advanced exam in my first attempt in 2020 with
                marks of 157 for 392 and rank of 3949.
              </div>
              <div>
                (b) I cleared JEE mains exam in 2020 with marks of 210 for 300
                and rank of 7804.
              </div>
            </div>
          </li>
          <li>
            <h3>
              <b style="font-family:'Poppins'">Codejuring | NIT Patna</b>
            </h3>
            <div style="text-align:left;padding-top:5px">
              I got 96th rank in coding competition by NIT patna called
              Codejuring.
            </div>
          </li>
          <li>
            <h3>
              <b style="font-family:'Poppins'">Hacktoberfest 2021</b>
            </h3>
            <div style="text-align:left;padding-top:5px">
              I have completed successfully 7 Pull Requests to different
              repositories to finish Hacktoberfest.
            </div>
          </li>
          <li>
            <h3>
              <b style="font-family:'Poppins'"> Milan | IIT Hyderabad</b>
            </h3>
            <div style="text-align:left;padding-top:5px">
              I and my team got 4th rank in Lambda Hackathon in Milan which is a
              inter Hostel General Championship.
            </div>
          </li>
        </ol>
      </main>
    </div>
  </MountingPortal>
</template>

<script>
import Animation from "./images/achievements.gif";
import Party from "./images/party.gif";
export default {
  data() {
    return {
      Animation: Animation,
      Party: Party,
    };
  },
};
</script>

<style scoped>
.honbe {
  position: absolute;
  right: 0;
  top: 6vh;
}
.hqiq {
  position: absolute;
  left: 0;
  bottom: 6vh;
}

.headitit img {
  height: 200px;
}
@media screen and (max-width: 600px) {
  .headitit img {
    height: 130px;
  }
}
.sixthslide {
  margin-left: 22vw;
  width: 78vw;
  font-family: "Roboto";
  /* margin-top: -0.8rem; */
  background: linear-gradient(#22487dcc, #22487de6, #22487def);
  min-height: 400px;
  /* overflow: hidden; */
}
#span {
  width: 6vw;
  padding-bottom: 1vh;
  margin-bottom: 2vh;
  margin: 0 2.2vw;
  /* border-bottom: 4px solid rgb(47, 65, 223); */
  border-bottom: 4px solid whitesmoke;
}
@media screen and (max-width: 768px) and (max-height: 1025px) {
  .sixthslide {
    margin-left: 0vw;
    width: 100vw;
  }
  #span {
    width: 17vw;
    padding-bottom: 1vh;
    margin-bottom: 2vh;
    /* border-bottom: 4px solid rgb(47, 65, 223); */
  }
  .hqiq {
    display: none;
  }
}
.headingstyle {
  font-size: 2.8rem;
  margin: 0 2.2vw;
  /* margin-bottom: 20px; */
  font-family: "Zen Antique Soft", serif;
  /* color: #173b6c; */
  color: white;
}
main {
  display: block;
  margin: 0 auto;
  max-width: 40rem;
  padding: 1rem;
}

ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
}

ol.gradient-list > li {
  background: white;
  border-radius: 0 0.5rem 0.5rem 0.5rem;
  counter-increment: gradient-counter;
  margin-top: 1rem;
  min-height: 3rem;
  padding: 1rem 1rem 1rem 3rem;
  position: relative;
}

ol.gradient-list > li::before,
ol.gradient-list > li::after {
  background: linear-gradient(135deg, #83e4e2 0%, #a2ed56 100%);
  border-radius: 1rem 1rem 0 1rem;
  content: "";
  height: 3rem;
  left: -1rem;
  overflow: hidden;
  position: absolute;
  top: -1rem;
  width: 3rem;
}

ol.gradient-list > li::before {
  align-items: flex-end;
  content: counter(gradient-counter);
  color: #1d1f20;
  display: flex;
  font: 900 1.5em/1 "Montserrat";
  justify-content: flex-end;
  padding: 0.125em 0.25em;
  z-index: 1;
}

ol.gradient-list > li:nth-child(10n + 1):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.2) 0%,
    rgba(253, 220, 50, 0.2) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 2):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.4) 0%,
    rgba(253, 220, 50, 0.4) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 3):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.6) 0%,
    rgba(253, 220, 50, 0.6) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 4):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.8) 0%,
    rgba(253, 220, 50, 0.8) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 5):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 1) 0%,
    rgba(253, 220, 50, 1) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 6):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.8) 0%,
    rgba(253, 220, 50, 0.8) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 7):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.6) 0%,
    rgba(253, 220, 50, 0.6) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 8):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.4) 0%,
    rgba(253, 220, 50, 0.4) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 9):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0.2) 0%,
    rgba(253, 220, 50, 0.2) 100%
  );
}

ol.gradient-list > li:nth-child(10n + 10):before {
  background: linear-gradient(
    135deg,
    rgba(162, 237, 86, 0) 0%,
    rgba(253, 220, 50, 0) 100%
  );
}

ol.gradient-list > li + li {
  margin-top: 2rem;
}
</style>
